import React, { Component } from 'react';
import styled from 'styled-components';

import theme from '../../styles/theme';
import Message from './Message.styled';

const MessageStyle = styled(Message)`
  i {
    color: ${theme.colors.warning};
  }
`;

type Props = {
  text: string;
  title?: string;
};

export default class SuccessMessage extends Component<Props> {
  render() {
    return (
      <MessageStyle>
        <div>
          <i className="material-icons">info_outline</i>
        </div>
        <div>
          <b>{this.props.title || 'Information'}</b>
          <p>{this.props.text}</p>
        </div>
      </MessageStyle>
    );
  }
}
